<!--
  Usage:

  <Tab to='/'>Home</Tab>
  <Tab to='/tab1'>Tab 1</Tab>
  <Tab to='/tab2'>Tab 2</Tab>

  Notes:

  + The "to" parameter is replaced as the ":tab" placeholder in the current
    route. This means that all links are relative to the current route.

-->

<template>
  <router-link
     :to="!external ? target : to"
      class="Tab"
     :class="{ 'Tab--disabled' : disabled }"
      exactActiveClass="Tab--active"
     :event="!disabled ? 'click' : ''">
    <slot></slot>
  </router-link>
</template>

<script>
  export default {
    props: {
      to: {
        type: String,
        default: '/',
      },

      disabled: {
        type: Boolean,
        default: false
      },

      external: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      target: function () {
        let path = this.$route.matched [0].path;

        for (let key in this.$route.params) {
          if (key !== 'tab') {
            path = path.replace (`:${key}`, encodeURIComponent (this.$route.params [key]));
          }
        }

        if (path.indexOf (':tab') === -1) {
          path = path.substring (0, path.lastIndexOf ('/')) + this.to;
        } else {
          path = path.replace (/\/?:tab\??/, this.to);
          path = path.replace (/\/$/, '');
        }
        return path;
      }
    }
  };
</script>

<style lang="scss">
  .Tab {
    &--active {
      color: fetch(colour active);
      border-bottom: fetch(border active);
    }

    &--disabled {
      color: fetch(colour disabled);

      &:hover {
        // cursor: auto;
        color: fetch(colour disabled);
        border-bottom: none;
      }
    }
  }
</style>